var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserStatistics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 52,
    viewBox: "0 0 63 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.30762,
    y: 23.7031,
    width: 12.8017,
    height: 27.0526,
    stroke: "#444444",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3011 37.7502C47.3011 37.7502 47.3011 35.4205 46.0342 34.6925C44.7674 33.9644 32.0988 34.6925 32.0988 34.6925C32.0988 34.6925 26.0178 27.8125 23.2308 27.8125C20.1903 27.8125 14.1094 27.8125 14.1094 27.8125V44.6302H19.6836C19.6836 44.6302 32.0988 51.0005 35.8993 51.0005C39.6999 51.0005 53.1286 41.0628 60.9832 35.7117C62.766 34.4971 60.9832 30.5228 57.9427 31.6347C55.1556 32.6539 47.3011 37.7502 47.3011 37.7502ZM47.3011 37.7502V39.7887H30.3252",
    stroke: "#444444",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2044 14.7679C54.2044 12.9598 53.8483 11.1695 53.1564 9.49913C52.4645 7.82874 51.4503 6.31098 50.1719 5.03251C48.8934 3.75405 47.3757 2.73992 45.7053 2.04802C44.0349 1.35612 42.2445 1 40.4365 1V14.7679H54.2044Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1855 15.0107C26.1855 22.7479 32.4578 29.0201 40.195 29.0201C46.8956 29.0201 52.4975 24.316 53.8782 18.03H36.9341V1.38281C30.7696 2.85239 26.1855 8.39623 26.1855 15.0107Z",
    stroke: "#444444",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStatistics);
export default __webpack_public_path__ + "static/media/User Statistics.3377adf73573c6919df8e6a7ac25d4c7.svg";
export { ForwardRef as ReactComponent };